<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
<div style="display: flex; margin-bottom: 15px">
  <div style="display: flex; justify-content: space-between; width: 100%">
    <h2 style="display: flex; justify-content: flex-start; gap: 5px">
      <span class="mat-text-primary font-weight-bold">
        Preview
        <vng-icon
          name="help_center"
          [outline]="false"
          color="purple"
          class="help-icon"
          ngbPopover="These views are intended to simulate what your FlyMSG would look like on both desktop and mobile view to an intended recipient."
        >
        </vng-icon>
      </span>
    </h2>
    <div style="display: flex; justify-content: flex-start; align-items: center">
      <div style="display: flex; justify-content: flex-start; align-items: center">
        <!-- R13: mat-slide-toggle -> vng-toggle. (change) -> (changed) bare boolean;
             label moves from content-projection to the `label` input. -->
        <!-- V3-13: vng-toggle has no labelPosition input (library gap vs.
             Material's labelPosition="before"), so its DOM order is always
             switch-then-label. The visual order is restored to master's
             label-then-switch with a `flex-direction: row-reverse` on
             .vng-toggle__label — see emulator-preview.component.scss. -->
        <vng-toggle label="Rich Text Preview" [(ngModel)]="checked" (changed)="switchViewer()"></vng-toggle>
      </div>
      <button
        type="button"
        vng-button
        variant="primary"
        tabindex="-1"
        (click)="copyLink()"
        style="height: 36px; margin: 0 15px"
      >
        Copy Shareable Link
      </button>
      <img
        *ngIf="isMax"
        src="../../../../../assets/images/min.png"
        alt=""
        srcset=""
        (click)="resize()"
        style="cursor: pointer"
        ngbPopover="Exit full screen"
      />
      <img
        *ngIf="!isMax"
        src="../../../../../assets/images/max.png"
        alt=""
        srcset=""
        (click)="resize()"
        style="cursor: pointer"
        ngbPopover="Full screen"
      />
    </div>
  </div>
</div>
<!-- emulator -->
<div style="display: flex; justify-content: space-around; padding: 0 31px">
  <div
    class="mobile-wrapper"
    style="
      border-radius: 11px;
      border: 2.5px solid #c8c8c8;
      width: 800px;
      max-width: 60%;
      border-left: 0;
      border-right: 0;
      background-color: #eaf0f6;
    "
  >
    <div class="mobile" style="border-radius: 7px; padding-bottom: calc(100vh - 310px); background-color: #eaf0f6">
      <div
        style="
          display: flex;
          padding-top: 0.5rem;
          padding-left: 0.5rem;
          border-bottom: 2.5px solid #c8c8c8;
          padding-bottom: 0.25rem;
          border-radius: 7px;
          background-color: white;
        "
      >
        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>

        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>

        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>
      </div>
      <div
        id="header"
        class="header"
        style="
          background-color: #e9e9e9;
          padding-left: 10px;
          padding-right: 10px;
          padding-bottom: 5px;
          display: grid;
          transform: none !important;
        "
      >
        <div class="navbar" style="display: block">
          <p style="margin: 4px 0">To: receiver&#64;email.com</p>
          <p style="margin: 4px 0">From: sender&#64;email.com</p>
          <p style="margin: 4px 0">Subject:</p>
        </div>
      </div>

      <!-- <div id="aside" class="aside"></div> -->
      <div class="screen" style="height: 70%; margin-top: 4rem">
        <!-- <div *ngIf="!checked" id="content" class="content" style="padding: 0; padding: 5px" [(innerHTML)]="html"></div> -->
        <editor
          *ngIf="checked && editorConfig"
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          style="border: none; padding: 0px 0 0; background-color: #eaf0f6"
          [(ngModel)]="html"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="content disabled noselect"
        >
        </editor>
        <textarea
          *ngIf="!checked"
          class="content textarea-padding"
          id="content"
          [(innerHTML)]="html"
          style="padding-left: 8px; border: 2px solid #eee; border-radius: 10px; background-color: white; resize: none"
          readonly
        ></textarea>

        <div class="footer">
          <hr />
        </div>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <div class="mobile-wrapper" style="max-width: 37%">
    <div class="mobile" style="border-top: 9px">
      <div class="photo"></div>

      <div
        class="screen"
        style="border: 3px solid #c8c8c8; padding-left: 0px; margin-left: 0.125rem; background-color: #eaf0f6"
      >
        <div id="os-header" class="os-header">
          <div class="notch-left">
            <i class="fad fa-signal-4"></i>
            <i class="fad fa-flask-potion"></i>
          </div>

          <div class="notch-right">
            <i class="far fa-battery-half"></i>
            <span id="time" class="hour"></span>
          </div>
        </div>
        <div id="header" class="header">
          <div class="navbar" style="display: block">
            <p style="margin: 4px 0">To: receiver&#64;email.com</p>
            <p style="margin: 4px 0">From: sender&#64;email.com</p>
            <p style="margin: 4px 0">Subject:</p>
          </div>
        </div>

        <!-- <div id="aside" class="aside"></div> -->

        <!-- <textarea name="" id="" cols="30" rows="10" [(innerHTML)]="html"></textarea> -->
        <editor
          *ngIf="checked && editorConfig"
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          style="border: none; padding: 0px 0 0; background-color: #eaf0f6"
          [(ngModel)]="html"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="disabled noselect mobile-content"
        >
        </editor>
        <textarea
          *ngIf="!checked"
          class="mobile-content textarea-padding"
          id="content"
          [(innerHTML)]="html"
          style="
            padding-left: 8px;
            border: 2px solid #eee;
            border-radius: 10px;
            background-color: white;
            resize: none;
            top: 0.95%;
          "
          readonly
        ></textarea>

        <!-- <div id="content" class="mobile-content" [(innerHTML)]="html"></div> -->

        <div class="footer">
          <hr />
        </div>
      </div>
    </div>
  </div>
  <!-- end mobile -->
</div>
<!-- end emulator -->
<div style="display: flex; justify-content: center; align-items: center">
  <!-- V3-04: master's footer Close is the orange outline variant, not ink-on-white. -->
  <button
    class="btn-cta btn-secondary"
    type="button"
    vng-button
    variant="outline"
    tabindex="-1"
    (click)="close()"
    style="width: 108px"
  >
    Close
  </button>
</div>
